/**
 * Emergency Launch Configuration
 * Controls temporary hiding of unready content for emergency site launch
 * To revert: Set all arrays to empty [] and flags to false
 * 
 * FEATURE FLAGS:
 * - showCalculatorBetaBanner: Shows beta banner on ROI calculator
 * - hideCalculatorShareButton: Hides share button on calculator
 * - showPDFDownload: Shows PDF download button on guide pages (disabled until ready)
 *   * When enabled, users can download guide content as formatted PDF
 *   * Uses raw MDX parsing for full content extraction
 *   * Zero performance impact when disabled (code never runs)
 *   * To activate: Set to true and deploy
 */

export const emergencyLaunchConfig = {
  // Navigation items to completely hide from main nav
  hiddenNavItems: ['Use Cases', 'Resources'],
  
  // Simple nav items to add (no mega menus) - these replace the hidden items
  addedNavItems: [
    { label: 'About', href: '/about-leadpops' },
    { label: 'Reviews', href: '/leadpops-reviews' },
    { label: 'Blog', href: '/blog' }
  ],
  
  // Footer columns to completely hide (For Loan Officers, For Brokers)
  hiddenFooterColumns: ['For Loan Officers', 'For Brokers'],
  
  // Individual footer links to hide within remaining columns
  hiddenFooterLinks: [
    '/mortgage-marketing-services',
    '/mortgage-marketing-analysis', 
    '/mortgage-growth-assessment',
    '/mortgage-lender-success-stories',
    '/mortgage-marketing-help-center',
    '/mortgage-marketing-webinars',
    '/contact-leadpops',
    '/careers-at-leadpops'
  ],
  
  // Pages to replace with iframes
  iframePages: {
    '/pricing': 'https://get-pricing-leadpops.secure-clix.com/'
  },
  
  // Reviews page widget embed code (to be provided)
  reviewsWidgetCode: '', // HTML embed code to be provided
  
  // Feature flags for ROI calculator and other components
  features: {
    showCalculatorBetaBanner: true,
    hideCalculatorShareButton: true,
    showPDFDownload: false  // PDF download button for guide pages - disabled until ready
  },
  
  // Sitemap filtering configuration
  // Prevents noindex pages from appearing in sitemaps (SEO best practice)
  // Set to false if you want noindex pages in sitemaps (not recommended)
  sitemapConfig: {
    respectRobotsNoindex: true  // Auto-exclude any page with robots: index: false
  },
  
  // List of pages that need noindex in frontmatter (for documentation)
  pagesRequiringNoindex: [
    // Use Cases pages
    '/use-cases',
    '/mortgage-social-media-marketing',
    '/mortgage-video-marketing',
    '/mortgage-content-marketing',
    '/mortgage-directory-marketing',
    '/mortgage-seo-marketing',
    '/mortgage-ppc-advertising',
    '/qr-code-mortgage-marketing',
    '/open-house-lead-generation',
    '/mortgage-offline-marketing',
    '/mortgage-recruiting-marketing',
    '/mortgage-team-branding',
    
    // Resources pages (excluding blog, guide, calculator)
    '/resources',
    '/mortgage-lender-success-stories',
    '/mortgage-marketing-webinars',
    '/mortgage-marketing-templates',
    '/mortgage-marketing-help-center',
    '/mortgage-marketing-api-documentation',
    '/contact-leadpops',
    
    // Additional pages from footer
    '/mortgage-marketing-services',
    '/mortgage-marketing-analysis',
    '/mortgage-growth-assessment',
    '/careers-at-leadpops',
    '/mortgage-broker-marketing',
    '/scale-your-mortgage-brokerage',
    '/mortgage-team-resources',
    '/leadpops-partner-program'
  ]
};